module.exports = __webpack_public_path__ + "img/erp_stimulate.390c4be0.jpg";